<template>
  <div class="doctor-consult-details">
    <div class="page_title flex between">
      <span>医生接诊统计-{{ $route.query.doctor_name }}医生</span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <!-- 搜索条件 -->
        <div class="doctor-consult-details-search">
          <el-form
            ref="doctorConsultDetailsFormRef"
            :inline="true"
            :model="doctorConsultDetailsForm"
            class="demo-form-inline"
          >
            <el-form-item label="时间">
              <el-date-picker
                v-model="doctorConsultDetailsForm.date"
                :clearable="false"
                type="daterange"
                unlink-panels
                range-separator="——"
                end-placeholder="结束日期"
                start-placeholder="开始日期"
                size="small"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="患者姓名">
              <el-input
                v-model="doctorConsultDetailsForm.user_name"
                clearable
                style="width: 160px"
                size="small"
              ></el-input>
            </el-form-item>

            <el-form-item label="患者手机号">
              <el-input
                v-model="doctorConsultDetailsForm.user_phone"
                clearable
                size="small"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" size="small" @click="searchBtn">
                查 询<i class="el-icon-search el-icon--right" />
              </el-button>

              <!-- 导出 -->
              <el-button
                type="primary"
                size="small"
                @click="derive"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1821') : false
                "
              >
                导出<i class="el-icon-download el-icon--right" />
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格 -->
        <div class="doctor-consult-details-table">
          <el-table
            v-loading="tableLoading"
            :header-cell-style="{ background: '#F5F5F5' }"
            :data="doctorConsultDetailsData"
            style="width: 100%"
            :span-method="mergeColumns"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              :fixed="item.fixed"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'user_info'">
                  <div>
                    {{ scope.row.real_name }}
                  </div>
                  <div>{{ scope.row.phone }}</div>
                </div>

                <div v-else-if="item.prop == 'time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'agree_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'over_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'is_prescription'">
                  {{
                    scope.row[item.prop] == 1
                      ? `是/${scope.row.prescription_list.length}`
                      : "否"
                  }}
                </div>

                <div v-else-if="item.prop == 'status'">
                  <span v-if="scope.row['is_prescription'] == 1">{{
                    scope.row[item.prop] | statusText
                  }}</span>
                  <span v-else>-------</span>
                </div>

                <div v-else>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null"
                      ? ""
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0] ? !module_id_array.includes('50') : false
                  "
                  @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>
    
    <script>
import Pagination from "@/components/Pagination/index.vue";
import dayjs from "dayjs";
import marketing from "@/api/marketing";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      moduleName: 1,
      doctorConsultDetailsForm: {
        user_name: "",
        user_phone: "",
        date: [],
      },
      total: 100,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      tableHeader: [
        {
          label: "患者信息",
          prop: "user_info",
          width: "120",
          fixed: "left",
        },
        {
          label: "问诊时间",
          prop: "time",
          width: "auto",
          fixed: false,
        },
        {
          label: "问诊接诊时间",
          prop: "agree_time",
          width: "auto",
          fixed: false,
        },
        {
          label: "问诊结束时间",
          prop: "over_time",
          width: "auto",
          fixed: false,
        },

        {
          label: "问诊费用",
          prop: "consult_money",
          width: "auto",
          fixed: false,
        },
        {
          label: "结束原因",
          prop: "over_str",
          width: "auto",
          fixed: false,
        },
        {
          label: "是否开方",
          prop: "is_prescription",
          width: "auto",
          fixed: false,
        },
        {
          label: "药品金额",
          prop: "prescription_money",
          width: "auto",
          fixed: false,
        },
        {
          label: "处方状态",
          prop: "status",
          width: "auto",
          fixed: false,
        },
      ],
      doctorConsultDetailsData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    statusText(val) {
      switch (val) {
        case 1:
          return "待取药";
        case 2:
          return "待审方";
        case 3:
          return "已通过";
        case 4:
          return "已抓药";
        case 5:
          return "过期未取药";
        case 6:
          return "审方不通过";
        case 7:
          return "医生手动作废";
        case 8:
          return "平台退款";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.doctorConsultDetailsForm.date = JSON.parse(this.$route.query.create_time);
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      let params = Object.assign(
        { doctor_id: this.$route.query.doctor_id },
        this.pagination,
        this.doctorConsultDetailsForm
      );
      params = _.omit(params, ["date"]);
      let times = this.doctorConsultDetailsForm.date;
      params["start_time"] = times ? dayjs(times[0]).format("YYYY-MM-DD") : "";
      params["end_time"] = times ? dayjs(times[1]).format("YYYY-MM-DD") : "";

      marketing.getDoctorConsultInfo(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.total = data.total;
          let arr = [];
          data.list.map((item) => {
            if (item.prescription_list.length) {
              item.prescription_list.map((j) => {
                arr.push(Object.assign({}, item, j));
              });
            } else {
              arr.push(Object.assign({}, item));
            }
          });
          this.doctorConsultDetailsData = arr;
          console.log(this.doctorConsultDetailsData);

          this.tableLoading = false;
        }
      });
    },
    // 查询
    searchBtn() {
      this.pagination.page = 1;
      this.getList();
    },
    // 导出
    derive() {
      const loading = this.$loading();
      let params = Object.assign(
        { doctor_id: this.$route.query.doctor_id },
        this.pagination,
        this.doctorConsultDetailsForm
      );
      params = _.omit(params, ["date"]);
      let times = this.doctorConsultDetailsForm.date;
      params["start_time"] = times ? dayjs(times[0]).format("YYYY-MM-DD") : "";
      params["end_time"] = times ? dayjs(times[1]).format("YYYY-MM-DD") : "";

      marketing
        .explodeDoctorConsultInfo(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${data.url}`;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    // 查看详情
    toDetail(row) {
      let { consult_id, consult_types } = row;
      this.$router.push({
        path: "/home/yewu/wenzhendetail",
        query: {
          consult_id,
          consult_types,
        },
      });
    },
    // 合并
    mergeColumns({ row, column, rowIndex, columnIndex }) {
      if (columnIndex != 7 && columnIndex != 8) {
        // 合并相同 consult_id 的单元格
        if (
          rowIndex > 0 &&
          this.doctorConsultDetailsData[rowIndex - 1].consult_id ===
            row.consult_id
        ) {
          return [0, 0]; // 不显示当前单元格
        }

        let count = 1;
        for (
          let i = rowIndex + 1;
          i < this.doctorConsultDetailsData.length;
          i++
        ) {
          if (this.doctorConsultDetailsData[i].consult_id === row.consult_id) {
            count++;
          } else {
            break;
          }
        }
        return [count, 1]; // 合并 count 行，1 列
      }
      return [1, 1]; // 默认不合并
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
    
    <style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 10px 20px;
}
.doctor-consult-details {
  .doctor-consult-details-search {
    display: flex;
    .el-form-item {
      margin-bottom: 10px;
    }
  }
  .doctor-consult-details-table {
    border: 1px solid #c9cdd6;
    // .el-table {
    // min-height: 476px;
    // }
  }
}
</style>
    